<template>
  <div class="">
    <!-- 聚焦點 -->
    <a href="javascript:;" class="hamb_h3" title="NEWS">NEWS</a>
    <!-- 最新消息 -->
    <a v-if="recentUpdateTotal>0" :href="`${serverRoot}/${recentUpdateUrl}`"><span></span>Recent Update</a>
    <!-- 最新消息 -->
    <a v-if="latestNewsTotal>0" :href="`${serverRoot}/${latestNewsUrl}`"><span></span>Latest News</a>
    <!-- 活動消息 -->
    <a v-if="activityNewsTotal>0" :href="`${serverRoot}/${activityNewsUrl}`"><span></span>Event News</a>
    <!-- 擔任國際要職 -->
    <a :href="`${serverRoot}/${interInvolvementUrl}`"><span></span>International Involvement</a>
    <!-- 學術獲獎榮譽 -->
    <a v-if="awardsTotal>0" :href="`${serverRoot}/${awardsUrl}`"><span></span>Awards / Honors</a>
    <!-- 國際會議邀請 -->
    <a v-if="symposiumTotal>0" :href="`${serverRoot}/${symposiumUrl}`"><span></span>Invitation To International Symposium</a>
  </div>
</template>

<script>
    import Constants from "../Constants";
    import utils from "../Utils";
    import _ from "lodash";
    export default {
        name: "FastLink",
        props: {
        },
        mixins: [utils],
        data() {
            return {

              serverRoot          :Constants.serverRoot,
              
              recentUpdateUrl     :'javascript:;',
              latestNewsUrl       :'javascript:;',
              activityNewsUrl     :'javascript:;',
              interInvolvementUrl :'javascript:;',
              awardsUrl           :'javascript:;',
              symposiumUrl        :'javascript:;',
              url:`${Constants.serverUrl}/api/about/news-count`,
              
              latestNewsTotal:0,
              activityNewsTotal:0,
              recentUpdateTotal:0,
              awardsTotal:0,
              symposiumTotal:0,
            };
        },
        created() {
        },
        mounted() {
          const _this = this
          _this.fetchNormalData(_this.url, '','pageData.contentData', function (response) {

            _this.latestNewsTotal   = _.get(response, 'data.Value.pageData.contentData.latestNewsTotal'  , 0)
            _this.activityNewsTotal = _.get(response, 'data.Value.pageData.contentData.activityNewsTotal', 0)
            _this.recentUpdateTotal = _.get(response, 'data.Value.pageData.contentData.recentUpdateTotal', 0)
            _this.awardsTotal       = _.get(response, 'data.Value.pageData.contentData.awardsTotal'      , 0)
            _this.symposiumTotal    = _.get(response, 'data.Value.pageData.contentData.symposiumTotal'   , 0)
            
            _this.latestNewsUrl       = _.get(response, 'data.Value.pageData.contentData.latestNewsUrl'      , 'javascript:;')
            _this.activityNewsUrl     = _.get(response, 'data.Value.pageData.contentData.activityNewsUrl'    , 'javascript:;')
            _this.recentUpdateUrl     = _.get(response, 'data.Value.pageData.contentData.recentUpdateUrl'    , 'javascript:;')
            _this.interInvolvementUrl = _.get(response, 'data.Value.pageData.contentData.interInvolvementUrl', 'javascript:;')
            _this.awardsUrl           = _.get(response, 'data.Value.pageData.contentData.awardsUrl'          , 'javascript:;')
            _this.symposiumUrl        = _.get(response, 'data.Value.pageData.contentData.symposiumUrl'       , 'javascript:;')
          })
        },
        methods: {
        },
        computed: {
          
        },
    };
</script>
